<mat-card>
<div class="main">

   
        <div class="row">
        
   <div class="col-md-2">
       <img src='{{user.image.url}}' class="userimg">
   </div>
    
  
    <div class="col-md-10 cls">
        <h2 class="heading1">PERSONAL INFORMATION</h2>
      <div class="row">
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>User Name</mat-label><mat-icon class="icon" >person</mat-icon>
                    <input  matInput placeholder="Username" name='name' [(ngModel)]="user.name" class="inp" disabled>
              </mat-form-field>
            </div>
       
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Email</mat-label><mat-icon class="icon" >email</mat-icon>
                    <input  matInput placeholder="Email" name='phone' [(ngModel)]="user.email" class="inp" disabled>
              </mat-form-field>
            
        </div>
        
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Phone</mat-label><mat-icon class="icon" >phone</mat-icon>
        
                    <input matInput placeholder="Password" name='phone' [(ngModel)]="user.phone" class="inp" disabled>
                  </mat-form-field>
           
        </div>
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Address</mat-label>
                <mat-icon class="icon" >location_on</mat-icon>
                    <input  matInput placeholder="User Address" name='address' [(ngModel)]="user.address" class="inp" disabled>
                  
                  </mat-form-field>
            </div>
    </div>
    </div>
    <div class="col-md-2"></div>
    <div class="col-md-10 cls">
        <form class="example-form" [formGroup]='userForm' (ngSubmit)="userForm.valid && changePassword(userForm.value)">
        <h2 class="heading1">Change Password</h2>
      <div class="row">
        <div class="col-md-4">
            <mat-form-field>
                <mat-label>Old Passsword</mat-label><mat-icon class="icon" (click)="changeVisibility(visibility)">{{visibility}}</mat-icon>
                    <input type='{{type}}' matInput placeholder="Old Password" name="name1" [(ngModel)]="oldPassword"  formControlName='username' formControlName='oldPassword' required>
                   
              </mat-form-field>
              <div *ngIf="msg" class="msg">
                {{this.msg}}
            </div>
           
            
            </div>
       
        <div class="col-md-4">

            <mat-form-field>
            <mat-label>New Password</mat-label>
            <mat-icon class="icon" (click)="changeVisibility1(visibility)">{{visibility1}}</mat-icon>
                <input type="password"  type='{{type1}}' matInput placeholder="New Password" [(ngModel)]="newPassword" name="new" formControlName='password' required>
                <mat-error *ngIf="userForm.hasError('passwordsDoNotMatch')">
                    Passwords do not match!
                  </mat-error>
              </mat-form-field>
              <div *ngIf="oldPassword==newPassword" class="msg">
                Please Enter New Password
                </div>
        </div>
        
        <div class="col-md-4">
            <mat-form-field>
            <mat-label>Confirm Password</mat-label>
    
                <input type="password" matInput placeholder="Verify Password" formControlName='verifyPassword' [errorStateMatcher]="errorMatcher" required> 
                <mat-error *ngIf="userForm.hasError('passwordsDoNotMatch')">
                  Passwords do not match!
                </mat-error>
              </mat-form-field>
        </div>
        <div class="col-md-4">
            <button mat-raised-button  class="add" [disabled]="userForm.invalid">Change Password</button>
        </div>
    </div> </form>
    </div>
</div> 
 

    </div>

  </mat-card>